module.exports = __webpack_public_path__ + "img/logo_sjm_mob.25622aef.png";